import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import ScrollToTop from "./components/ScrollToTop";
import Navigation from "./components/ui/navigation";
import Footer from "./components/ui/footer";
import FaviconUpdater from "./components/FaviconUpdater";
import { TranslationProvider } from "./hooks/useTranslation";
import WhatsAppFloat from "./components/site/WhatsAppFloat";
import CookieBanner from "./components/site/CookieBanner";

import SEOHead from "./components/SEOHead";
import Home from "./pages/Home";
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Contact = lazy(() => import("./pages/Contact"));
const TourDetail = lazy(() => import("./pages/TourDetail"));
const Checkout = lazy(() => import("./pages/Checkout"));
const BookingConfirmation = lazy(() => import("./pages/BookingConfirmation"));
const BookingCancellation = lazy(() => import("./pages/BookingCancellation"));
const Admin = lazy(() => import("./pages/Admin"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <TranslationProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen bg-background font-sans antialiased">
            <SEOHead />
            <FaviconUpdater />
            <div className="min-h-screen flex flex-col">
              <Navigation />
              <main className="flex-1">
                <Suspense fallback={<div className="min-h-[60vh]" />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/tour/:slug" element={<TourDetail />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/booking-confirmation" element={<BookingConfirmation />} />
                  <Route path="/booking-cancellation" element={<BookingCancellation />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/p/:slug" element={<LandingPage />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/contact" element={<Contact />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
                </Suspense>
              </main>
              <Footer />
              <WhatsAppFloat />
              <CookieBanner />
            </div>
          </div>
        </BrowserRouter>
      </TranslationProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;